import { render, staticRenderFns } from "./CityPostcode.vue?vue&type=template&id=8983c010&scoped=true"
import script from "./CityPostcode.vue?vue&type=script&lang=ts"
export * from "./CityPostcode.vue?vue&type=script&lang=ts"
import style0 from "./CityPostcode.vue?vue&type=style&index=0&id=8983c010&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8983c010",
  null
  
)

export default component.exports